import { fetchRequestInterceptors } from "@faire/help-center/initialize/requestInterceptors";
import { responseInterceptors } from "@faire/help-center/initialize/responseInterceptors";
import { datadogInterceptor } from "@faire/web--source/common/events/interceptors/datadogInterceptor";
import { facebookInterceptor } from "@faire/web--source/common/events/interceptors/facebookInterceptor";
import { hotjarInterceptor } from "@faire/web--source/common/events/interceptors/hotjarInterceptor";
import { requestHandler as fetchRequestHandler } from "@faire/web--source/common/requests/handlers/fetch";
import {
  addEventInterceptor,
  addRequestInterceptor,
  addResponseInterceptor,
  setRequestHandler,
} from "@faire/web-api--source";

export const init = () => {
  responseInterceptors.forEach(addResponseInterceptor);

  fetchRequestInterceptors.forEach(addRequestInterceptor);
  setRequestHandler(fetchRequestHandler);

  addEventInterceptor(datadogInterceptor);
  addEventInterceptor(facebookInterceptor);
  addEventInterceptor(hotjarInterceptor);
};
